(function installBssBundleReorderRestore() {
  'use strict';

  if (window.__bonoirBssReorderRestoreInstalled) return;
  window.__bonoirBssReorderRestoreInstalled = true;

  var originalFetch = window.fetch.bind(window);
  var appBaseUrl = 'https://bonoir-bundle-production.up.railway.app/api/reorder';
  var bssOrdersPath = '/apps/customer-portal/api/shopify/get-orders';
  var bssSubmitPath = '/apps/customer-portal/api/ro-order/submit';
  var bundleProductId = '10496703005011';
  var bundleProductJsonPath = '/products/bundel-doos.js';
  var bundleVariantIds = ['53293751566675', '53293751599443', '53650406539603', '53650412208467'];
  var knownOrders = [];
  var activeSourceOrderId = null;
  var activeSourceOrderName = null;
  var activeDetailedErrorMessage = null;

  function getUrl(input) {
    try {
      return new URL(typeof input === 'string' ? input : input.url, window.location.href);
    } catch (_error) {
      return null;
    }
  }

  function parseRequestBody(init) {
    if (!init || typeof init.body !== 'string') return null;
    try {
      return JSON.parse(init.body);
    } catch (_error) {
      return null;
    }
  }

  function timeoutSignal() {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () {
      controller.abort();
    }, 12000);
    return { controller: controller, timeout: timeout };
  }

  function rememberOrders(response) {
    response.clone().json().then(function (payload) {
      knownOrders = Array.isArray(payload && payload.data) ? payload.data : [];
    }).catch(function () {});
  }

  function getBssRoot() {
    var host = document.querySelector('bss-ro');
    return host && host.shadowRoot;
  }

  function getModalSourceOrderId() {
    var root = getBssRoot();
    var modal = root && root.querySelector('bss-ro-reorder-modal');
    return modal && modal.reorderOrder && modal.reorderOrder.id;
  }

  function renderDetailedReorderError() {
    if (!activeDetailedErrorMessage) return false;

    var root = getBssRoot();
    var modal = root && root.querySelector('bss-ro-reorder-modal');
    var message = modal && modal.querySelector('.bss-ro-reorder-modal__banner .bss-ro-banner__message');
    if (!message) return false;

    var detailedMessage = 'Herbestellen niet mogelijk: ' + activeDetailedErrorMessage;
    if (message.textContent !== detailedMessage) {
      message.textContent = detailedMessage;
    }
    return true;
  }

  function showDetailedReorderError(message) {
    activeDetailedErrorMessage = message || 'De gekozen bonbons konden niet veilig worden overgenomen.';

    [0, 50, 150, 350, 750, 1500, 2500].forEach(function (delay) {
      window.setTimeout(renderDetailedReorderError, delay);
    });
  }

  function clearDetailedReorderError() {
    activeDetailedErrorMessage = null;
  }

  function isBundleProductSearch(url) {
    if (!url.pathname.endsWith('/search.js') || url.searchParams.get('view') !== 'bss.bcp') {
      return false;
    }
    return String(url.searchParams.get('q') || '').includes('id:"' + bundleProductId + '"');
  }

  async function includeHiddenBundleProduct(input, init) {
    var bssResponse = await originalFetch(input, init);
    if (!bssResponse.ok) return bssResponse;

    try {
      var payload = await bssResponse.clone().json();
      var products = Array.isArray(payload)
        ? payload
        : Array.isArray(payload && payload.products)
          ? payload.products
          : Array.isArray(payload && payload.results)
            ? payload.results
            : null;
      if (!products || products.some(function (product) {
        return String(product && product.id) === bundleProductId;
      })) {
        return bssResponse;
      }

      var productResponse = await originalFetch(bundleProductJsonPath, {
        headers: { Accept: 'application/json' },
      });
      if (!productResponse.ok) return bssResponse;
      var bundleProduct = await productResponse.json();
      if (!bundleProduct || String(bundleProduct.id) !== bundleProductId) return bssResponse;

      var restoredPayload;
      if (Array.isArray(payload)) {
        restoredPayload = products.concat(bundleProduct);
      } else if (Array.isArray(payload.products)) {
        restoredPayload = Object.assign({}, payload, { products: products.concat(bundleProduct) });
      } else {
        restoredPayload = Object.assign({}, payload, { results: products.concat(bundleProduct) });
      }

      return new Response(JSON.stringify(restoredPayload), {
        status: bssResponse.status,
        statusText: bssResponse.statusText,
        headers: { 'Content-Type': 'application/json' },
      });
    } catch (error) {
      console.error('[Bonoir] Verborgen bundeldoos kon niet aan BSS worden doorgegeven', error);
      return bssResponse;
    }
  }

  function rememberClickedOrder(event) {
    var path = event.composedPath ? event.composedPath() : [];
    var isReorderClick = path.some(function (node) {
      if (!node || !node.getAttribute) return false;
      var label = node.getAttribute('text') || node.textContent || '';
      return /^(nabestellen|reorder|opnieuw bestellen|bestelling opnieuw plaatsen)$/i.test(String(label).trim());
    });
    if (!isReorderClick) return;

    var orderName = '';
    for (var index = 0; index < path.length; index += 1) {
      var text = path[index] && path[index].textContent;
      var match = String(text || '').match(/#\d+/);
      if (match) {
        orderName = match[0];
        break;
      }
    }

    if (orderName) activeSourceOrderName = orderName;
    clearDetailedReorderError();

    var order = knownOrders.find(function (candidate) {
      return String(candidate && candidate.name || '') === orderName;
    });
    if (order && order.id) activeSourceOrderId = order.id;
  }

  document.addEventListener('click', rememberClickedOrder, true);

  function failedDraftResponse(originalResponse, originalPayload, message) {
    var payload = Object.assign({}, originalPayload, {
      success: false,
      error: {
        message: message || 'De gekozen bonbons konden niet veilig worden overgenomen. Probeer het opnieuw.',
      },
    });
    return new Response(JSON.stringify(payload), {
      status: 200,
      statusText: originalResponse.statusText,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function failedCartResponse(message) {
    return new Response(JSON.stringify({
      status: 422,
      description: message || 'De gekozen bonbons konden niet veilig worden overgenomen.',
    }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async function addBundlePropertiesToCart(requestPayload, sourceOrderId, sourceOrderName) {
    var requestTimeout = timeoutSignal();
    try {
      var response = await originalFetch(appBaseUrl + '/cart-properties', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sourceOrderId: sourceOrderId,
          sourceOrderName: sourceOrderName,
          items: requestPayload.items,
        }),
        signal: requestTimeout.controller.signal,
      });
      var payload = await response.json();
      if (!response.ok || !payload.success || !Array.isArray(payload.items)) {
        throw new Error(payload.error || 'Bundle-properties ontbreken');
      }
      return payload;
    } finally {
      window.clearTimeout(requestTimeout.timeout);
    }
  }

  async function restoreDraftOrder(requestPayload, bssResponse) {
    var bssPayload;
    try {
      bssPayload = await bssResponse.clone().json();
    } catch (_error) {
      return bssResponse;
    }

    var draftOrderId = bssPayload && bssPayload.draftOrder && bssPayload.draftOrder.id;
    if (!bssPayload.success || !draftOrderId) return bssResponse;

    var requestTimeout = timeoutSignal();
    try {
      var restoreResponse = await originalFetch(appBaseUrl + '/restore', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sourceOrderId: requestPayload.sourceOrderId,
          draftOrderId: draftOrderId,
        }),
        signal: requestTimeout.controller.signal,
      });
      var restorePayload = await restoreResponse.json();
      if (!restoreResponse.ok || !restorePayload.success) {
        showDetailedReorderError(restorePayload.error);
        return failedDraftResponse(bssResponse, bssPayload, restorePayload.error);
      }
      return bssResponse;
    } catch (error) {
      console.error('[Bonoir] Conceptorder kon niet veilig worden hersteld', error);
      showDetailedReorderError(error.message);
      return failedDraftResponse(bssResponse, bssPayload);
    } finally {
      window.clearTimeout(requestTimeout.timeout);
    }
  }

  async function validateDraftReorder(requestPayload) {
    var requestTimeout = timeoutSignal();
    try {
      var response = await originalFetch(appBaseUrl + '/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sourceOrderId: requestPayload.sourceOrderId }),
        signal: requestTimeout.controller.signal,
      });
      var payload = await response.json();
      if (!response.ok || !payload.success) {
        throw new Error(payload.error || 'De voorraad van de gekozen bonbons kon niet worden gecontroleerd.');
      }
    } finally {
      window.clearTimeout(requestTimeout.timeout);
    }
  }

  window.fetch = async function bonoirFetch(input, init) {
    var url = getUrl(input);
    if (!url) return originalFetch(input, init);

    if (isBundleProductSearch(url)) {
      return includeHiddenBundleProduct(input, init);
    }

    if (url.pathname === bssOrdersPath) {
      var ordersResponse = await originalFetch(input, init);
      if (ordersResponse.ok) rememberOrders(ordersResponse);
      return ordersResponse;
    }

    if (url.pathname.endsWith('/cart/add.js')) {
      var cartPayload = parseRequestBody(init);
      var sourceOrderId = getModalSourceOrderId() || activeSourceOrderId;
      var containsBundle = cartPayload && Array.isArray(cartPayload.items) && cartPayload.items.some(function (item) {
        return bundleVariantIds.includes(String(item && item.id));
      });
      if (!cartPayload || !Array.isArray(cartPayload.items)) {
        return originalFetch(input, init);
      }
      if (!sourceOrderId && !activeSourceOrderName) {
        return containsBundle
          ? failedCartResponse('De oorspronkelijke bestelling kon niet worden gekoppeld. Vernieuw de pagina en probeer opnieuw.')
          : originalFetch(input, init);
      }

      try {
        var restoredCart = await addBundlePropertiesToCart(
          cartPayload,
          sourceOrderId,
          activeSourceOrderName
        );
        if (restoredCart.restoredItems) {
          console.info(
            '[Bonoir] Bundelsamenstelling aan winkelwagen toegevoegd:',
            restoredCart.restoredItems,
            'regel(s)'
          );
        }
        return originalFetch(input, Object.assign({}, init, {
          body: JSON.stringify(Object.assign({}, cartPayload, { items: restoredCart.items })),
        }));
      } catch (error) {
        console.error('[Bonoir] Winkelwagen-bundel kon niet veilig worden hersteld', error);
        return failedCartResponse(error.message);
      }
    }

    if (url.pathname !== bssSubmitPath) {
      return originalFetch(input, init);
    }

    var requestPayload = parseRequestBody(init);
    if (!requestPayload || !requestPayload.sourceOrderId) {
      return originalFetch(input, init);
    }

    try {
      await validateDraftReorder(requestPayload);
    } catch (error) {
      console.error('[Bonoir] Herbestelling geblokkeerd door voorraadcontrole', error);
      showDetailedReorderError(error.message);
      return failedDraftResponse(
        new Response('', { status: 200 }),
        {},
        error.message
      );
    }

    var bssResponse = await originalFetch(input, init);
    if (!bssResponse.ok) return bssResponse;
    return restoreDraftOrder(requestPayload, bssResponse);
  };
})();
